module.exports = __webpack_public_path__ + "d22fb2707d75257bb877474029e818fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/franca.png
// module id = 1047
// module chunks = 0